module.exports = __webpack_public_path__ + "static/media/covid.bce0d387.jpeg";